import { render, staticRenderFns } from "./RightBar.vue?vue&type=template&id=ab66c582&scoped=true"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"
import style0 from "./RightBar.vue?vue&type=style&index=0&id=ab66c582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab66c582",
  null
  
)

export default component.exports